import { Controller } from '@hotwired/stimulus'
import { MediaImage } from '../../api/models/types'
import computedValues from '../../helpers/computedValues'
import {
  connectUserData,
  getComponentContext,
  lifecycleTrigger,
} from '../../helpers/controllerHelpers/utils'

type ImageTarget = {
  src: string
  removeAttribute: (src: string) => void
}

export default class extends Controller {
  static targets = ['image']
  static values = { src: String }

  declare hasImageTarget: boolean
  declare imageTarget: ImageTarget
  declare srcValue: string
  component: MediaImage
  flowEl: Element | null

  connect() {
    const { component, flowEl } = getComponentContext(this)
    this.component = component as MediaImage
    this.flowEl = flowEl
    lifecycleTrigger(this, 'mounted')
  }

  disconnect() {
    lifecycleTrigger(this, 'unmounted')
  }
}
